import cliente from './AxiosCliente'; 

const url = 'controller/anuncio.php'; 

export default class {

    mostrar = (usuario_id) => {
        let formData = new FormData();
        formData.append('funcion', 'mostrar');
        formData.append('usuario_id', usuario_id);
        
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }


    ingresar = (titulo, contenido, fecha, ciclo_id, usuario_id) => {
        let formData = new FormData();
        formData.append('funcion', 'ingresar');
        formData.append('titulo', titulo);
        formData.append('contenido', contenido);
        formData.append('fecha', fecha);
        formData.append('ciclo_id', ciclo_id);
        formData.append('usuario_id', usuario_id);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }

    editar = (id, titulo, contenido, fecha, ciclo_id, usuario_id) => {
        let formData = new FormData();
        formData.append('funcion', 'editar');
        formData.append('id', id);
        formData.append('titulo', titulo);
        formData.append('contenido', contenido);
        formData.append('fecha', fecha);
        formData.append('ciclo_id', ciclo_id);
        formData.append('usuario_id', usuario_id);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }



    eliminar = (id) => {
        let formData = new FormData();
        formData.append('funcion', 'eliminar');
        formData.append('id', id);

        let consulta =  cliente.post({url: url, data: formData})
        return consulta;
    }


    paraEstudiante = (ciclo_id) => {
        let formData = new FormData();
        formData.append('funcion', 'paraestudiantes')
        formData.append('ciclo_id', ciclo_id)
        
        let consulta =  cliente.post({url: url, data: formData})
        return consulta;

    }



}